(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
(() => {
  const HEART = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7.5-4.6-9.5-9.2C1.2 8.4 3.4 5 6.9 5c2 0 3.4 1.1 4.1 2.2C11.7 6.1 13.1 5 15.1 5c3.5 0 5.7 3.4 4.4 6.8C17.5 16.4 12 21 12 21z"/></svg>';
  const BUBBLE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M4 5h16v11H9l-5 4z"/></svg>';
  const MULTI = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/></svg>';
  const PLAY = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const n = (x) => (x >= 1000 ? (x / 1000).toFixed(1).replace(/\.0$/, '') + 'k' : String(x));
  const lang = document.documentElement.lang || 'en';

  document.querySelectorAll('[data-igf]').forEach(async (sec) => {
    const grid = sec.querySelector('[data-igf-grid]');
    const count = Number(sec.dataset.count) || 6;
    let posts = [], cur = 0;
    try {
      const r = await fetch('/apps/everyd/social/feed?count=' + count + '&sort=' + encodeURIComponent(sec.dataset.sort || 'recent'), { headers: { Accept: 'application/json' } });
      if (!r.ok) return;
      const d = await r.json();
      if (!d.ok || !d.posts?.length) return;
      posts = d.posts;
      const acc = d.account?.ig;
      if (acc) {
        sec.querySelectorAll('[data-igf-avatar]').forEach((a) => { if (acc.avatar) a.style.backgroundImage = 'url("' + acc.avatar + '")'; });
        const stats = sec.querySelector('[data-igf-stats]');
        if (stats && (acc.followers || acc.posts)) stats.textContent = (acc.followers ? n(acc.followers) + ' ' + (lang.startsWith('ar') ? 'متابع' : 'followers') + ' · ' : '') + n(acc.posts) + ' ' + (lang.startsWith('ar') ? 'بوست' : 'posts');
        if (acc.link) sec.querySelector('[data-igf-acct]').href = acc.link;
      }
    } catch { return; }

    grid.innerHTML = posts.map((p, i) => '<li class="igf__item"><button type="button" data-i="' + i + '" aria-label="' + esc((p.caption || '').split('\n')[0].slice(0, 90) || 'Instagram post') + '">'
      + '<img src="' + esc(p.image) + '" alt="" loading="lazy" decoding="async">'
      + (p.type === 'carousel' ? '<span class="igf__badge" aria-hidden="true">' + MULTI + '</span>' : p.type === 'video' ? '<span class="igf__badge" aria-hidden="true">' + PLAY + '</span>' : '')
      + (p.likes || p.comments ? '<span class="igf__ov" aria-hidden="true">' + (p.likes ? '<span>' + HEART + n(p.likes) + '</span>' : '') + (p.comments ? '<span>' + BUBBLE + n(p.comments) + '</span>' : '') + '</span>' : '') + '</button></li>').join('');
    sec.hidden = false;
    sec.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-in'));

    /* lightbox */
    const dlg = sec.querySelector('[data-igf-dlg]');
    if (!dlg || typeof dlg.showModal !== 'function') { grid.addEventListener('click', (e) => { const b = e.target.closest('button[data-i]'); if (b) window.open(posts[b.dataset.i].link, '_blank', 'noopener'); }); return; }
    const show = (i) => {
      cur = (i + posts.length) % posts.length;
      const p = posts[cur];
      dlg.querySelector('[data-igf-img]').src = p.image;
      dlg.querySelector('[data-igf-cap]').textContent = p.caption || '';
      dlg.querySelector('[data-igf-meta]').innerHTML = (p.likes ? '<span>' + HEART + ' ' + n(p.likes) + '</span>' : '') + (p.comments ? '<span>' + BUBBLE + ' ' + n(p.comments) + '</span>' : '');   // zero counts say nothing useful
      const t = dlg.querySelector('[data-igf-time]'); t.dateTime = p.at; t.textContent = new Date(p.at).toLocaleDateString(lang.startsWith('ar') ? 'ar-EG' : 'en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
      dlg.querySelector('[data-igf-open]').href = p.link;
    };
    grid.addEventListener('click', (e) => { const b = e.target.closest('button[data-i]'); if (!b) return; show(Number(b.dataset.i)); dlg.showModal(); document.documentElement.style.overflow = 'hidden'; });
    dlg.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
    dlg.querySelector('[data-igf-close]').addEventListener('click', () => dlg.close());
    dlg.querySelector('[data-igf-prev]').addEventListener('click', () => show(cur - 1));
    dlg.querySelector('[data-igf-next]').addEventListener('click', () => show(cur + 1));
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    const rtl = getComputedStyle(dlg).direction === 'rtl';
    dlg.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') show(cur + (rtl ? -1 : 1)); if (e.key === 'ArrowLeft') show(cur + (rtl ? 1 : -1)); });
    let sx = null, sy = 0;   // swipe the image to page through posts
    const media = dlg.querySelector('.igf__dlg-media');
    media.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    media.addEventListener('touchend', (e) => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null; if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(cur + ((dx < 0) !== rtl ? 1 : -1)); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-revs]');
    if (!root) return;
    const S = JSON.parse(document.querySelector('[data-revs-strings]')?.textContent || '{}');
    const dialog = root.querySelector('[data-revs-dialog]');
    const form = root.querySelector('[data-revs-form]');
    const errorEl = root.querySelector('[data-revs-error]');
    const submit = root.querySelector('[data-revs-submit]');
    const photos = root.querySelector('[data-revs-photos]');
    const previews = root.querySelector('[data-revs-previews]');

    root.querySelector('[data-revs-open]')?.addEventListener('click', () => dialog.showModal());
    root.querySelectorAll('[data-revs-close]').forEach((b) => b.addEventListener('click', () => dialog.close()));

    /* The post-purchase email links carry a signed token (?rv=…) that already
       proves the purchase — so drop the order-number and phone questions and
       let the shopper write straight away. */
    const verifyBox = root.querySelector('[data-revs-verify]');
    const verifyError = root.querySelector('[data-revs-verify-error]');
    const step2 = root.querySelector('[data-revs-step2]');
    const moreDetails = root.querySelector('[data-revs-more-details]');
    let verified = false;

    const showVerifyError = (msg) => { verifyError.textContent = msg; verifyError.hidden = false; };

    const unlock = (rv, profile = {}) => {
      verified = true;
      if (rv) {
        const tokenInput = form.querySelector('[data-revs-token]');
        tokenInput.value = rv;
        tokenInput.disabled = false;
      }
      verifyBox.hidden = true;
      verifyBox.querySelectorAll('input').forEach((i) => { i.required = false; });
      ['author', 'city'].forEach((k) => { if (profile[k]) form.elements[k].value = profile[k]; });
      const parts = [profile.author, profile.city].filter(Boolean);
      root.querySelector('[data-revs-summary]').textContent = parts.length ? `${S.postingAs} ${parts.join(' · ')}` : '';
      if (profile.author) root.querySelector('[data-revs-invited-text]').textContent = S.verifiedHi.replace('[name]', profile.author);
      moreDetails.open = !profile.author;
      root.querySelector('[data-revs-invited]').hidden = false;
      step2.hidden = false;
    };

    const invited = new URL(window.location.href).searchParams.get('rv');
    if (invited) {
      unlock(invited);
      fetch(`/apps/everyd/reviews/invite?rv=${encodeURIComponent(invited)}`)
        .then((r) => r.json())
        .then((d) => { if (d.ok) unlock(null, d.profile); else if (S[d.error]) { errorEl.textContent = S[d.error]; errorEl.hidden = false; } })
        .catch(() => { moreDetails.open = true; });
    }

    /* Links from the "Delivered" email land on #write-review-<stars>: open the
       form with that rating already picked. */
    const fromEmail = window.location.hash.match(/^#write-review(?:-([1-5]))?(?:-(\d{3,10}))?$/);
    if (fromEmail) {
      if (fromEmail[1]) {
        const star = form.querySelector(`#rv-star-${fromEmail[1]}`);
        if (star) star.checked = true;
      }
      if (fromEmail[2]) form.querySelector('[data-revs-order]').value = fromEmail[2];
      root.scrollIntoView({ block: 'start' });
      dialog.showModal();
      form.querySelector(verified ? 'textarea[name="body"]' : fromEmail[2] ? 'input[name="contact"]' : '[data-revs-order]')?.focus();
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });

    root.querySelector('[data-revs-show-more]')?.addEventListener('click', (e) => {
      root.querySelectorAll('[data-revs-more]').forEach((li) => { li.hidden = false; });
      e.currentTarget.remove();
    });

    root.querySelectorAll('[data-revs-filter]').forEach((btn) => btn.addEventListener('click', () => {
      const photosOnly = btn.dataset.revsFilter === 'photos';
      root.querySelectorAll('[data-revs-filter]').forEach((b) => b.classList.toggle('is-active', b === btn));
      root.querySelectorAll('.rev').forEach((li) => {
        li.hidden = photosOnly ? li.dataset.photos !== 'true' : li.hasAttribute('data-revs-more');
      });
      root.querySelector('[data-revs-show-more]')?.toggleAttribute('hidden', photosOnly);
    }));

    photos?.addEventListener('change', () => {
      if (photos.files.length > 3) {
        errorEl.textContent = S.photoLimit;
        errorEl.hidden = false;
        photos.value = '';
      } else {
        errorEl.hidden = true;
      }
      previews.innerHTML = '';
      [...photos.files].slice(0, 3).forEach((f) => {
        const img = document.createElement('img');
        img.src = URL.createObjectURL(f);
        img.alt = '';
        previews.appendChild(img);
      });
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errorEl.hidden = true;
      verifyError.hidden = true;

      /* Step one: check the order, get the token and the shopper's details. */
      if (!verified) {
        const order = form.elements.order.value.trim();
        const contact = form.elements.contact.value.trim();
        if (!order || !contact) return showVerifyError(S.verifyMissing);
        const btn = root.querySelector('[data-revs-continue]');
        const label = btn.textContent;
        btn.disabled = true;
        btn.textContent = S.checking;
        try {
          const res = await fetch('/apps/everyd/reviews/verify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ order, contact, product_id: form.elements.product_id.value }),
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || !data.ok) throw new Error(res.status === 429 ? S.tooMany : S[data.error] || S.error);
          unlock(data.rv, data.profile);
          form.querySelector('#rv-star-5')?.focus();
        } catch (err) {
          showVerifyError(err.message || S.error);
        } finally {
          btn.disabled = false;
          btn.textContent = label;
        }
        return;
      }

      if (!form.checkValidity()) {
        if (form.querySelector('[data-revs-more-details] :invalid')) moreDetails.open = true;
        errorEl.textContent = S.invalid;
        errorEl.hidden = false;
        form.querySelector(':invalid')?.focus();
        return;
      }

      const label = submit.textContent;
      submit.disabled = true;
      submit.textContent = S.sending;
      try {
        const res = await fetch('/apps/everyd/reviews/submit', { method: 'POST', body: new FormData(form) });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.ok) {
          throw new Error(res.status === 429 ? S.tooMany : res.status === 422 ? S.invalid : S[data.error] || S.error);
        }
        const thanks = root.querySelector('[data-revs-thanks]');
        if (data.published && thanks) thanks.textContent = thanks.dataset.live;
        root.querySelector('[data-revs-done]').hidden = false;
        form.reset();
        previews.innerHTML = '';
      } catch (err) {
        errorEl.textContent = err.message || S.error;
        errorEl.hidden = false;
      } finally {
        submit.disabled = false;
        submit.textContent = label;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
